import type { HelpFile } from '../../types/help'
import { AssignmentDecisionsTestIds } from '../../../testids/AssignmentDecisionsTestIds'

export const assignmentDecisionsHelp: HelpFile = {
  docPage: '/docs/governance/certification-reviews',
  texts: {
    [AssignmentDecisionsTestIds.assignmentDecisionsPage]:
      'Prüfen Sie jede Zugriffszuweisung in dieser Kampagne und entscheiden Sie, ob sie beibehalten oder entzogen werden soll.',
    [AssignmentDecisionsTestIds.cardTitleAllAssignments]:
      'Vollständige Liste der zu prüfenden Zugriffszuweisungen. Entscheiden Sie pro Zeile mit den Schaltflächen, oder markieren Sie mehrere Zeilen für eine Sammelentscheidung.',
    [AssignmentDecisionsTestIds.btnCertify]:
      'Alle Entscheidungen einreichen und die Kampagne für diese Zuweisungen abschließen.',
    [AssignmentDecisionsTestIds.btnPrevItem]: null,
    [AssignmentDecisionsTestIds.btnNextItem]: null,
    [AssignmentDecisionsTestIds.btnBulkDecide]:
      'Dieselbe Behalten/Entziehen-Entscheidung für alle markierten Zuweisungen auf einmal anwenden.',
    [AssignmentDecisionsTestIds.bulkBtnKeep]: null,
    [AssignmentDecisionsTestIds.bulkBtnRevoke]:
      'Zugriff für alle markierten Zeilen entziehen — wird nach Kampagnenabschluss provisioniert.',
    [AssignmentDecisionsTestIds.bulkBtnUndecided]:
      'Markierte Zeilen für spätere Prüfung auf „unentschieden" zurücksetzen.',
    [AssignmentDecisionsTestIds.inputBulkComment]:
      'Optionaler Kommentar, der für jede Entscheidung dieser Sammelaktion gespeichert wird — sinnvoll zur Begründung von Entzügen.',
    [AssignmentDecisionsTestIds.colDecision]:
      'Ihre aktuelle Entscheidung für die Zuweisung — beibehalten, entziehen oder unentschieden.',
    [AssignmentDecisionsTestIds.assignmentDecisionsCount]: null,
  },
}
